import { render, staticRenderFns } from "./doctorList.vue?vue&type=template&id=d5e53422&scoped=true&"
import script from "./doctorList.vue?vue&type=script&lang=js&"
export * from "./doctorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e53422",
  null
  
)

export default component.exports